import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss']
})
export class DocumentationComponent implements OnInit, OnDestroy {

  document : string;

  destroy$ = new Subject<any>();

  constructor(private route : ActivatedRoute) { }

  ngOnInit() {

    var $paramsChanged = this.route.params;
    $paramsChanged.pipe(takeUntil(this.destroy$)).subscribe(
      params => {
        this.document = params["file"];
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  navigate(document)
  {
    this.document = document;
  }

}
